import React from "react";

const benefits = [
  "No upfront payments",
  "Getting your activity online takes under 30 minutes",
  "Fixed commission on successful bookings",
];

const table = [
  {
    title: "Technical knowledge required",
    description: "Expertise needed for efficient management",
    intraverse: "No technical skills",
    online: "Require technical expertise",
    offline: "Require technical expertise",
  },
  {
    title: "Cost structure",
    description: "Payment method for each acquired customer",
    intraverse: "Fixed commission fee",
    online: "Variable costs based on the ad efficiency",
    offline: "Variable costs based on the ad efficiency",
  },
  {
    title: "Time to get started",
    description: "Onboarding time to start promoting your activity",
    intraverse: "<30 minutes",
    online: ">2 hours",
    offline: ">2 weeks",
  },
  {
    title: "Customer service support",
    description:
      "Handling traveler inquiries and resolving issues on your behalf",
    intraverse: "Yes",
    online: "No",
    offline: "No",
  },
];

function HomeCompareSection() {
  const handleGetStarted = () => {};
  return (
    <div className={Classname.container}>
      <div className={Classname.content}>
        <span className="font-bold text-2xl lg:text-4xl text-center">
          Compare Intraverse to other marketing activities
        </span>

        <div className="w-full overflow-scroll scroll-hide mt-10 lg:mt-20 mb-20">
          <div className={Classname.row}>
            <div className={Classname.column1}></div>
            <div className={Classname.headerCell}>
              <span>Intraverse</span>
              <span></span>
            </div>
            <div className={Classname.headerCell}>
              <span>Online advertising</span>
              <span>(e.g. Google Ads)</span>
            </div>
            <div className={Classname.headerCell}>
              <span>Offline marketing</span>
              <span>(e.g. outdoor advertising)</span>
            </div>
          </div>
          <div className={Classname.divider}></div>

          {table.map((row, index) => (
            <div key={index} className="w-full">
              <div className={Classname.row}>
                <div className={Classname.column1}>
                  <span>{row.title}</span>
                  <span className={Classname.column1description}>
                    {row.description}
                  </span>
                </div>
                <div className={Classname.column2}>
                  <span>{row.intraverse}</span>
                </div>
                <div className={Classname.column3}>
                  <span>{row.online}</span>
                </div>
                <div className={Classname.column4}>
                  <span>{row.offline}</span>
                </div>
              </div>
              {index !== table.length - 1 && (
                <div className={Classname.divider}></div>
              )}
            </div>
          ))}
        </div>

        <div className="w-full flex items-center justify-center mb-10">
          <button
            className="h-14 w-80 bg-primary rounded-md flex items-center justify-center text-white text-sm lg:text-base font-bold"
            onClick={handleGetStarted}
          >
            Get Started
          </button>
        </div>

        <ul className="flex flex-col lg:flex-row gap-2 lg:gap-10 object-center list-disc text-sm mb-20 px-2">
          {benefits.map((benefit, index) => (
            <li className="" key={index}>
              {benefit}
            </li>
          ))}
        </ul>
      </div>
    </div>
  );
}

export default HomeCompareSection;

const Classname = {
  container:
    "w-full flex justify-center pt-20 px-basicx xl:px-0 font-main relative",
  content: "w-full flex flex-col max-w-7xl px-2 xl:px-0 items-center",
  row: "w-full flex justify-between font-bold text-sm lg:text-base gap-4 relative",
  headerCell: "flex flex-col items-center w-72 flex-shrink-0",
  column1: "flex flex-col w-96 flex-shrink-0",
  column1description: "font-normal",
  column2:
    "flex flex-col items-center text-primary w-72 text-center flex-shrink-0",
  column3:
    "flex flex-col items-center text-[#EC1C3C] w-72 text-center flex-shrink-0",
  column4:
    "flex flex-col items-center text-[#EC1C3C] w-72 text-center flex-shrink-0",
  divider: "border-b-2 border-[#0000001C] my-6 flex flex-1",
};
